// extracted by mini-css-extract-plugin
export default {"SnapppayCancel":"SnapppayCancel_SnapppayCancel__BlbcB","Form":"SnapppayCancel_Form__PGf4D","FlexRow":"SnapppayCancel_FlexRow__8tfi9","Username":"SnapppayCancel_Username__Ycex1"};